import { render, staticRenderFns } from "./points-details.vue?vue&type=template&id=2a76feb5&scoped=true"
import script from "./points-details.vue?vue&type=script&lang=js"
export * from "./points-details.vue?vue&type=script&lang=js"
import style0 from "./points-details.vue?vue&type=style&index=0&id=2a76feb5&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a76feb5",
  null
  
)

export default component.exports